var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{attrs:{"hideBackBtn":true,"color":"grey lighten-3","autofocus":false}})}
var staticRenderFns = []

export { render, staticRenderFns }